module.exports = __webpack_public_path__ + "afbc8674910a45e840bd9758914aefe3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bonds-issue-circle-2.png
// module id = 1615
// module chunks = 0